import { combineReducers } from 'redux';

import payroll from './payroll';

export default combineReducers({
  payroll,
});
